import { render, staticRenderFns } from "./linkProductsToGroupTable.vue?vue&type=template&id=8bc3c73e"
import script from "./linkProductsToGroupTable.vue?vue&type=script&lang=js"
export * from "./linkProductsToGroupTable.vue?vue&type=script&lang=js"
import style0 from "./linkProductsToGroupTable.vue?vue&type=style&index=0&id=8bc3c73e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports